{
  "#AI_AGENT": {
    "TITLE": "KI-Agent",
    "CHAT_PAGE_TITLE": "KI-Agent – Chat",
    "PANEL_TITLE": "KI-Agent",
    "PLACEHOLDER": "Frage zur Umsatzstatistik eingeben…",
    "SEND": "Senden",
    "THINKING": "Denkt nach…",
    "TOOL_RUNNING": "Frage Statistik ab:",
    "TOOL_CLIENT_RUNNING": "Führe aus:",
    "NEW_CONVERSATION": "Neue Unterhaltung",
    "EMPTY": "Stellen Sie eine Frage zur Umsatzstatistik.",
    "ERROR": "Fehler:",
    "HOP_LIMIT": "Zu viele aufeinanderfolgende Aktionen – Abfrage abgebrochen.",
    "CONTEXT_CHIPS": "Kontext",
    "MENTION_PICK_ENTITY": "Stammdaten wählen",
    "CHART": "Diagramm",
    "TABLE": "Tabelle",
    "MENTION_CLOSE": "Suche schließen"
  }
}
